import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Star, CheckCircle, Shield } from 'lucide-react';
import Disclaimer from '../components/Disclaimer';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Reviews = () => {
  const reviews = [
    {
      id: 1,
      name: 'Betclic',
      slug: 'betclic',
      bonus: 'Bonus de bienvenue jusqu\'à 100€',
      rating: 4.5,
      description: 'L\'un des leaders historiques du marché français, Betclic allie réputation solide et offre complète pour tous les types de parieurs.',
      color: 'from-blue-500 to-blue-700',
      bgColor: 'bg-blue-50',
    },
    {
      id: 2,
      name: 'Olybet',
      slug: 'olybet',
      bonus: 'Bonus de bienvenue de 100€',
      rating: 4.3,
      description: 'Une plateforme moderne et intuitive qui séduit par son interface soignée et ses conditions de retrait avantageuses.',
      color: 'from-purple-500 to-purple-700',
      bgColor: 'bg-purple-50',
    },
    {
      id: 3,
      name: 'Genybet',
      slug: 'genybet',
      bonus: 'Bonus de bienvenue de 200€ + 50€ de paris gratuits',
      rating: 4.7,
      description: 'L\'offre la plus généreuse du marché avec un bonus exceptionnel et une expertise reconnue dans les paris hippiques.',
      color: 'from-green-500 to-green-700',
      bgColor: 'bg-green-50',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Disclaimer />
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" data-discover="true" className="inline-flex items-center text-purple-600 hover:text-purple-700 mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Link>

        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-purple-600 rounded-full mb-6">
            <Star className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Avis et Comparatifs des Sites de Paris
          </h1>
          <p className="text-2xl text-gray-600 max-w-3xl mx-auto">
            Analyses approfondies et détaillées des meilleurs sites de paris agréés en France
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {reviews.map((review) => (
            <Link
              key={review.id}
              to={`/reviews/${review.slug}`}
              data-discover="true"
              className={`${review.bgColor} rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-105`}
            >
              <div className={`bg-gradient-to-r ${review.color} p-6 text-white`}>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-2xl font-bold">{review.name}</h3>
                  <div className="flex items-center gap-1">
                    <Star className="w-5 h-5 fill-current" />
                    <span className="text-lg font-semibold">{review.rating}</span>
                  </div>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3">
                  <p className="font-semibold">{review.bonus}</p>
                </div>
              </div>
              
              <div className="p-6">
                <p className="text-gray-700 mb-4 leading-relaxed">
                  {review.description}
                </p>
                <div className="flex items-center text-purple-600 font-semibold">
                  Lire l'avis complet
                  <CheckCircle className="ml-2 w-5 h-5" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <Shield className="w-6 h-6 text-purple-600" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900">
              Notre Méthodologie d'Évaluation
            </h2>
          </div>
          <div className="prose prose-lg max-w-none text-gray-700 space-y-4 leading-relaxed">
            <p>
              Chaque avis que nous publions est le résultat d'une analyse approfondie et d'un test réel de la plateforme. Nous ne nous 
              contentons pas de compiler des informations publiques : nous créons réellement un compte, testons les processus de dépôt et 
              de retrait, analysons les cotes proposées, évaluons la qualité du service client, et utilisons l'interface pendant plusieurs 
              semaines avant de rédiger notre avis.
            </p>
            <p>
              Nos critères d'évaluation incluent : la sécurité et la fiabilité (agrément ANJ, réputation, historique), la qualité de l'offre 
              (cotes, variété des marchés, bonus), l'expérience utilisateur (interface, navigation, fonctionnalités), le service client 
              (disponibilité, réactivité, compétence), et la valeur globale (rapport qualité-prix, conditions de retrait, transparence).
            </p>
            <p>
              Tous les sites que nous évaluons sont agréés par l'Autorité Nationale des Jeux (ANJ), garantissant leur légalité et leur 
              conformité aux normes françaises. Nous ne recommandons jamais un site non agréé, quelle que soit son offre ou sa réputation 
              internationale.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Reviews;

